import { RouterStates } from './router-states.constant';

export const routerStateNotFound = {
  path: '**',
  redirectTo: '/' + RouterStates.login /** PAGE NOT FOUND */,
};
